export const Z_INDEXES = {
  indexPlus: 30,
  mobileMenuContent: 29,
  mobileMenu: 28,
  mobileMenuBlur: 27,
};
